export const thunkTypes = {
  GET_TEAM: `team/getTeam`,
  LIST_DELIVERIES: `team/listDeliveries`,
};
